module.exports = __webpack_public_path__ + "img/vo-way-2.8c4164c3.svg";